import { createContext } from 'react'

import { staticAssets } from './static-assets'

export type StaticAssetContextType = {
  getAsset: <T extends keyof typeof staticAssets>(key: T) => (typeof staticAssets)[typeof key]
}

export const StaticAssetContext = createContext<StaticAssetContextType>(null)
